import React from 'react'
import PropTypes from 'prop-types'

function Dot (props) {
  return (
    <span className='Dot' style={{
      transitionDuration: '300ms',
      opacity: props.selected ? '1' : '0.3'
    }} />
  )
}

export default function IndicatorDots (props) {

  if (props.total < 2) {
    // Hide dots when there is only one dot.
    return <div className='Indicator-Dots'/>
  } else {
    return (
      <div className='Indicator-Dots'>{
        Array.apply(null, Array(props.total)).map((x, i) => {
          return <Dot key={i} selected={props.index === i} />
        })
      }</div>
    )
  }
}

IndicatorDots.propTypes = {
  index: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
}
